import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function TeamMemberRender({ node }) {
  const content = node.content || {};
  
  const name = content.name || 'Jane Doe';
  const role = content.role || 'Senior Developer';
  const bio = content.bio || 'Spezialistin für React und Frontend-Architektur. Liebt sauberen Code.';
  const imageUrl = content.imageUrl || 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=600&auto=format&fit=crop';
  
  const align = content.align || 'center';
  const avatarSize = content.avatarSize || '120px';

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: align,
      textAlign: align,
      gap: '16px',
      padding: '24px',
      background: 'rgba(255,255,255,0.02)',
      borderRadius: '16px',
      border: '1px solid rgba(255,255,255,0.05)',
      transition: 'transform 0.2s ease',
      cursor: 'default'
    }}>
      <div style={{
        width: avatarSize,
        height: avatarSize,
        borderRadius: '50%',
        overflow: 'hidden',
        border: '3px solid var(--tef-primary, #00A9E0)',
        boxShadow: '0 8px 24px rgba(0, 169, 224, 0.2)'
      }}>
        <img 
          src={imageUrl} 
          alt={name}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </div>
      
      <div>
        <h3 style={{ margin: '0 0 4px 0', fontSize: '20px', color: '#f8fafc', fontWeight: 'bold' }}>{name}</h3>
        <p style={{ margin: '0 0 12px 0', fontSize: '14px', color: 'var(--tef-primary, #00A9E0)', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{role}</p>
        <p style={{ margin: 0, fontSize: '14px', color: '#cbd5e1', lineHeight: '1.6' }}>{bio}</p>
      </div>

      {/* Social Icons Placeholder */}
      <div style={{ display: 'flex', gap: '12px', marginTop: '8px' }}>
        <a href="#" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '18px' }}>in</a>
        <a href="#" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '18px' }}>GH</a>
        <a href="#" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '18px' }}>X</a>
      </div>
    </div>
  );
}

registry.register('TeamMember', {
  label: 'Team Mitglied',
  icon: '🧑‍💼', 
  category: 'advanced',
  component: TeamMemberRender,
  
  defaultProps: {
    content: {
      name: 'Dr. Markus Haas',
      role: 'CEO Telefónica Deutschland',
      bio: 'Treibt die Digitalisierung und den 5G-Ausbau in Deutschland vehement voran.',
      imageUrl: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?q=80&w=600&auto=format&fit=crop',
      align: 'center',
      avatarSize: '120px'
    },
    style: {
      desktop: {
        width: '100%',
        marginBottom: '20px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Person',
          fields: [
            { name: 'content.name', label: 'Name', type: 'text' },
            { name: 'content.role', label: 'Rolle / Position', type: 'text' },
            { name: 'content.bio', label: 'Kurz-Bio', type: 'textarea' },
            { name: 'content.imageUrl', label: 'Portrait Bild (URL)', type: 'text' }
          ]
        },
        {
          title: 'Darstellung',
          fields: [
            { name: 'content.align', label: 'Ausrichtung', type: 'select', options: ['flex-start', 'center', 'flex-end'] },
            { name: 'content.avatarSize', label: 'Bild-Größe (z.B. 120px)', type: 'text' }
          ]
        }
      ]
    }
  ]
});
